module.exports = __webpack_public_path__ + "static/media/user-guide-btn.1dfb5a8f.png";